export const divisionsAndDepartmentsSelector = state =>
  state.divisionsAndDepartments;
